"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var recaptcha_component_1 = require("./recaptcha/recaptcha.component");
exports.RecaptchaComponent = recaptcha_component_1.RecaptchaComponent;
var recaptcha_loader_service_1 = require("./recaptcha/recaptcha-loader.service");
exports.RecaptchaLoaderService = recaptcha_loader_service_1.RecaptchaLoaderService;
exports.RECAPTCHA_LANGUAGE = recaptcha_loader_service_1.RECAPTCHA_LANGUAGE;
var recaptcha_module_1 = require("./recaptcha/recaptcha.module");
exports.RecaptchaModule = recaptcha_module_1.RecaptchaModule;
var recaptcha_settings_1 = require("./recaptcha/recaptcha-settings");
exports.RECAPTCHA_SETTINGS = recaptcha_settings_1.RECAPTCHA_SETTINGS;



//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/ng-recaptcha/index.js
// module id = ../../../../ng-recaptcha/index.js
// module chunks = 4